import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://app.b3rastreamento.com.br/api';

function Login() {
  const [tela, setTela] = useState('codigo'); // 'codigo' | 'login' | 'esqueci'
  const [codigo, setCodigo] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [emailEsqueci, setEmailEsqueci] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [mensagemEsqueci, setMensagemEsqueci] = useState('');
  const [tenant, setTenant] = useState(null);
  const [buscandoTenant, setBuscandoTenant] = useState(false);

  useEffect(() => {
    // Verifica se já tem código salvo
    const codigoSalvo = localStorage.getItem('tenant_codigo');
    if (codigoSalvo) {
      setCodigo(codigoSalvo);
      buscarTenant(codigoSalvo);
    }
  }, []);

  const buscarTenant = async (cod) => {
    if (!cod) return;
    setBuscandoTenant(true);
    setErro('');
    try {
      const res = await axios.get(`${API}/tenants/codigo/${cod.toUpperCase()}`);
      setTenant(res.data);
      localStorage.setItem('tenant_codigo', cod.toUpperCase());
      setTela('login');
    } catch (err) {
      setErro('Código de acesso inválido. Verifique e tente novamente.');
      setTenant(null);
    }
    setBuscandoTenant(false);
  };

  const confirmarCodigo = async (e) => {
    e.preventDefault();
    await buscarTenant(codigo);
  };

  const trocarCodigo = () => {
    setTenant(null);
    setTela('codigo');
    setErro('');
    setEmail('');
    setSenha('');
  };

  const cor = tenant?.cor_primaria || '#1D9E75';

  const entrar = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, senha });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('usuario', JSON.stringify(res.data.usuario));
      window.location.href = '/dashboard';
    } catch (err) {
      setErro(err.response?.data?.erro || 'Email/login ou senha incorretos');
    }
    setCarregando(false);
  };

  const solicitarRedefinicao = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setMensagemEsqueci('');
    try {
      await axios.post(`${API}/senha/solicitar`, { email: emailEsqueci });
      setMensagemEsqueci('✅ Se este email estiver cadastrado, você receberá as instruções em breve. Verifique sua caixa de entrada e spam.');
    } catch (err) {
      setMensagemEsqueci('❌ Erro ao enviar email. Tente novamente.');
    }
    setEnviando(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: '420px' }}>

        {/* Logo e nome do tenant */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          {tenant?.logo_url ? (
            <img src={tenant.logo_url} alt={tenant.nome} style={{ maxHeight: '80px', maxWidth: '260px', objectFit: 'contain', marginBottom: '12px' }} />
          ) : (
            <div style={{ fontSize: '48px', marginBottom: '12px' }}>🛰️</div>
          )}
          {!tenant?.logo_url && (
            <h1 style={{ color: 'white', fontSize: '28px', fontWeight: '700', margin: 0 }}>
              {tenant?.nome || 'Rastreamento Veicular'}
            </h1>
          )}
          <p style={{ color: 'rgba(255,255,255,0.6)', margin: '8px 0 0', fontSize: '14px' }}>Rastreamento Veicular</p>
        </div>

        <div style={{ background: 'white', borderRadius: '16px', padding: '32px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>

          {/* TELA: Código de acesso */}
          {tela === 'codigo' && (
            <>
              <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <div style={{ fontSize: '40px', marginBottom: '8px' }}>🔑</div>
                <h2 style={{ margin: '0 0 8px', fontSize: '20px', color: '#333' }}>Código de Acesso</h2>
                <p style={{ color: '#999', fontSize: '13px', margin: 0 }}>Digite o código fornecido pela sua empresa</p>
              </div>
              <form onSubmit={confirmarCodigo}>
                <div style={{ marginBottom: '20px' }}>
                  <input
                    type="text"
                    placeholder="Ex: B3"
                    value={codigo}
                    onChange={e => setCodigo(e.target.value.toUpperCase())}
                    required
                    style={{ width: '100%', padding: '14px', borderRadius: '8px', border: '2px solid #e0e0e0', fontSize: '18px', boxSizing: 'border-box', outline: 'none', textAlign: 'center', letterSpacing: '4px', fontWeight: '700' }}
                  />
                </div>
                {erro && (
                  <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px', textAlign: 'center' }}>
                    ❌ {erro}
                  </div>
                )}
                <button type="submit" disabled={buscandoTenant || !codigo}
                  style={{ width: '100%', padding: '12px', background: buscandoTenant || !codigo ? '#ccc' : '#1D9E75', color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: buscandoTenant || !codigo ? 'not-allowed' : 'pointer' }}>
                  {buscandoTenant ? '⏳ Verificando...' : '✅ Confirmar'}
                </button>
              </form>
            </>
          )}

          {/* TELA: Login */}
          {tela === 'login' && (
            <>
              <h2 style={{ margin: '0 0 24px', fontSize: '20px', color: '#333', textAlign: 'center' }}>Entrar na plataforma</h2>
              <form onSubmit={entrar}>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ fontSize: '13px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '6px' }}>Email ou Login</label>
                  <input type="text" placeholder="seu@email.com ou seu login" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="username"
                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} />
                </div>
                <div style={{ marginBottom: '8px' }}>
                  <label style={{ fontSize: '13px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '6px' }}>Senha</label>
                  <input type="password" placeholder="••••••••" value={senha} onChange={e => setSenha(e.target.value)} required autoComplete="current-password"
                    style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                  <button type="button" onClick={trocarCodigo}
                    style={{ background: 'none', border: 'none', color: '#999', fontSize: '12px', cursor: 'pointer' }}>
                    🔑 Alterar código
                  </button>
                  <button type="button" onClick={() => { setTela('esqueci'); setErro(''); setMensagemEsqueci(''); }}
                    style={{ background: 'none', border: 'none', color: cor, fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>
                    Esqueci minha senha
                  </button>
                </div>
                {erro && (
                  <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '16px' }}>
                    ❌ {erro}
                  </div>
                )}
                <button type="submit" disabled={carregando}
                  style={{ width: '100%', padding: '12px', background: carregando ? '#ccc' : cor, color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: carregando ? 'not-allowed' : 'pointer' }}>
                  {carregando ? '⏳ Entrando...' : '🚀 Entrar'}
                </button>
              </form>
            </>
          )}

          {/* TELA: Esqueci senha */}
          {tela === 'esqueci' && (
            <>
              <h2 style={{ margin: '0 0 8px', fontSize: '20px', color: '#333', textAlign: 'center' }}>🔐 Esqueci minha senha</h2>
              <p style={{ color: '#999', fontSize: '13px', textAlign: 'center', marginBottom: '24px' }}>
                Digite seu email e enviaremos um link para redefinir sua senha.
              </p>
              {!mensagemEsqueci ? (
                <form onSubmit={solicitarRedefinicao}>
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ fontSize: '13px', color: '#666', fontWeight: '600', display: 'block', marginBottom: '6px' }}>Email cadastrado</label>
                    <input type="email" placeholder="seu@email.com" value={emailEsqueci} onChange={e => setEmailEsqueci(e.target.value)} required
                      style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', outline: 'none' }} />
                  </div>
                  <button type="submit" disabled={enviando}
                    style={{ width: '100%', padding: '12px', background: enviando ? '#ccc' : cor, color: 'white', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: enviando ? 'not-allowed' : 'pointer', marginBottom: '12px' }}>
                    {enviando ? '⏳ Enviando...' : '📧 Enviar link de redefinição'}
                  </button>
                  <button type="button" onClick={() => setTela('login')}
                    style={{ width: '100%', padding: '12px', background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>
                    ← Voltar ao login
                  </button>
                </form>
              ) : (
                <div>
                  <div style={{ background: mensagemEsqueci.startsWith('✅') ? '#E1F5EE' : '#FCEBEB', color: mensagemEsqueci.startsWith('✅') ? '#0F6E56' : '#A32D2D', padding: '14px', borderRadius: '10px', fontSize: '13px', lineHeight: '1.6', marginBottom: '16px', textAlign: 'center' }}>
                    {mensagemEsqueci}
                  </div>
                  <button type="button" onClick={() => { setTela('login'); setMensagemEsqueci(''); setEmailEsqueci(''); }}
                    style={{ width: '100%', padding: '12px', background: '#f0f0f0', color: '#666', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>
                    ← Voltar ao login
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.4)', fontSize: '12px', marginTop: '24px' }}>
          Desenvolvido por Digital Mais BR
        </p>
      </div>
    </div>
  );
}

export default Login;